import { ContinueButton, PlayerOrb } from '../zen-ui';

/** Chapter 0 — a single seed of light, a title, an invitation. */
export function Intro({ onBegin }: { onBegin: () => void }) {
  return (
    <div className="relative z-10 flex min-h-dvh flex-col items-center justify-center gap-8 px-6 py-24 text-center">
      <div className="animate-zen-fade-in" style={{ animationDelay: '300ms' }}>
        <PlayerOrb size={18} />
      </div>

      <h1
        className="animate-zen-fade-up zen-text-glow font-serif text-6xl italic leading-none text-amber-50 sm:text-8xl"
        style={{ animationDelay: '600ms' }}
      >
        zen relay
      </h1>

      <p
        className="animate-zen-fade-up font-serif text-xl italic text-slate-300/85 sm:text-2xl"
        style={{ animationDelay: '950ms' }}
      >
        a quiet journey into nostr
      </p>

      <p
        className="animate-zen-fade-up font-sans text-[11px] uppercase tracking-[0.45em] text-white/35"
        style={{ animationDelay: '1300ms' }}
      >
        five gentle lessons · two quiet minutes
      </p>

      <ContinueButton onClick={onBegin} label="begin" delay={1700} className="pt-4" />
    </div>
  );
}
